module.exports = __webpack_public_path__ + "static/media/StateFarm.5149aa48.svg";